varying vec3 vWorldPosition;
varying float vDistanceFromCamera;

uniform vec3 uCameraPosition;

void main() {
    vec4 worldPosition = modelMatrix * vec4(position, 1.0);
    vWorldPosition = worldPosition.xyz;

    // Calculate distance from camera (horizontal only, ignore Y)
    vec2 horizontalDist = worldPosition.xz - uCameraPosition.xz;
    vDistanceFromCamera = length(horizontalDist);

    gl_Position = projectionMatrix * viewMatrix * worldPosition;
}
